import { CancelToken } from "axios";
import api from "./api";
import { SymbolAllRes } from "interfaces/response";
import { SymbolAllReq } from "interfaces/request";
import { GET_SYMBOL_ALL } from "constants/api";

export const getSymbolAll = (payload: SymbolAllReq, cancelToken: CancelToken) => {
    return api.post<SymbolAllRes>(GET_SYMBOL_ALL, payload, { cancelToken });
};
